import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hayat_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setToken = (t) => localStorage.setItem("hayat_token", t);
export const clearToken = () => localStorage.removeItem("hayat_token");
export const getToken = () => localStorage.getItem("hayat_token");
export { API };
